import { useSelector } from "react-redux"
import "./AverageWPM.scss";
import { useEffect, useState } from "react";
import WPMLoader from "../WPMLoader/WPMLoader";
export default function AverageWPM(){
    const { practice_WPM } = useSelector(state => state.game);   
    const [ wpm,setWPM ] = useState(practice_WPM);
    const [ loaderFlag, setLoaderFlag ] = useState(false);
    const [ WPMFlag, setWPMFlag ] = useState(false);
    useEffect(()=>{
        if (practice_WPM !== wpm){            
            if (practice_WPM < wpm){
                setWPMFlag(prevWPM => prevWPM = false);
            }
            else{
                setWPMFlag(prevWPM => prevWPM = true);
            }
            setWPM(prevWPM => prevWPM = practice_WPM)
            setLoaderFlag(true);
        }
    },[wpm,practice_WPM])
    useEffect(()=>{
        let animationLoader;        
        if(loaderFlag === true){
            animationLoader = setTimeout(()=>{
                setLoaderFlag(false)
            }, 1300);
        }
        return () => clearTimeout(animationLoader);
    },[loaderFlag])
    return(
        <div className="averageWPM">
             <span>
                <u>
                Practice WPM:&nbsp;
                </u>                
                {loaderFlag ?
                    <WPMLoader
                    higher={WPMFlag}
                    />: 
                    <span>
                        {Math.floor(practice_WPM)}
                    </span>
                }                              
            </span>
        </div>
    )
}